Services = require('lib/Services').default
Dispatcher = require('Dispatcher').default
promisify = require("../lib/promisify").default
SuperRecordStore = require("data/SuperRecordStore").default
TableStore = require("data/TableStore").default
StereotypesStore = require("data/StereotypesStore").default
SuperRecordActions = require("data/SuperRecordActions").default
ClientId = require("data/ClientId").default
DataEntryControllerJS = require("./DataEntryControllerJS").default
appAlert = require("lib/withOver").appAlert

module.exports = class DataEntryController extends DataEntryControllerJS
    events:
        "entity:load": "onConfirmLoadEntity"
        "entity:new": "onConfirmEntityNew"
        "load:entity_data": "onDataEntry"
        "confirm:load:entity_data": "onConfirmDataEntry"
        "confirm:user:logout": "onConfirmUserLogout"
        "entity:save": "onSaveEntity"
        "validation:load": "onValidationLoadEntity"
        "record:open": "onRecordOpen"
        "record:new-child": "onRecordNewChild" # for both magic and non-magic

    queue: []

    onLoadEntity: (searchResult, appModel)=>
        org = searchResult.owner
        mrCoords = searchResult.magicRootCoordinates

        # if this is a lookup there wont be magic root
        # but it will have a key
        if mrCoords?
            key = mrCoords.key
            id = mrCoords.id
        else
            key = searchResult.key
            id = searchResult.id

        [form, data] = [null, null]
        if mrCoords
            if searchResult.magicRoot
                @dispatch('navigate', org, key, id)
                @onDataEntry(org, key, id, undefined, undefined, undefined, appModel)
            else
                @dispatch('navigate', org, key, id, searchResult.key, searchResult.id)
                @onDataEntry(org, key, id, searchResult.key, searchResult.id, undefined, appModel)
        else if key.indexOf('/') > 0
            # three-part entity key
            @onDataEntry(org, key, id, key, id, undefined, appModel)
        else
            @onDataEntry(org, key, id, undefined, undefined, undefined, appModel)

    activateNewEntity: (entity, key, id, ekey, eid, shortname, appModel) =>
        impls = @getImplFromProjection(entity.projections)
        if ekey != undefined
            # it's be awesome to combine this w/ onValidationLoadEntity, but
            # there's still to much navigation/focus collusion
            [ekey, eid, shortname] = entity.findNearestParent(ekey, eid, shortname)
            try
                Backbone.dispatcher.trigger(
                    "record:open",
                    ekey,
                    eid,
                    shortname,
                    appModel,
                )
            catch e
                console.warn 'not navigable', ekey, eid, shortname

        else if impls.length == 1
            styp = appModel.get('searchState').get('stereotype')
            if styp != undefined
                creatables = styp.get('creatables')
                if creatables.length == 1
                    creatable = creatables.first()
                    if creatable.get('defaultKey')
                        Backbone.dispatcher.trigger(
                            "record:open",
                            creatable.get('defaultKey'),
                            id,
                            shortname,
                            appModel,
                        )

    getImplFromProjection: (projections)->
        impls = {}
        _(projections).each (p, key, list)->
            impls[key.split('/')[0]] = 0

        return _.keys(impls)




// WEBPACK FOOTER //
// ./app/controllers/DataEntryController.coffee